<template>
  <div class="search">

    <div class="container">
      <button class="search__back" @click="goBack"></button>
      <img class="search__artwork" src="../assets/img/search.png" alt="">
    </div>

    <transition mode="out-in" name="fade">
      <div
        class="search__formwrap container container--wide" 
      >
        
        <form id="search-form" @submit="onSubmit" class="search__form form">

          <h2 class="search__title">Enter your name</h2>

          <div class="form__field">
            <div :class="['form__field', errors.search && 'form__field--error']">
              <!-- <label for="search">Forename</label> -->
              <input type="text" name="search" v-model="search" />
              <p class="form__errors" v-if="errors.search">
                {{ errors.search }}
              </p>
            </div>
          </div>

          <p class="search__recaptcha">This site is protected by reCAPTCHA and the Google <a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy">Privacy Policy</a> and <a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/terms">Terms of Service</a> apply.</p>
        
          <button 
            class="button button--primary search__cta search__cta"
            type="submit"
            form="search-form"
            :disabled="!search"
            v-if="!submitting"
          >
            Search
          </button>
          <div v-else class="search__loader search__cta"></div>

        </form>

        <div class="search__brick">
          <div class="search__select">
            <div class="search__slider">
              <div class="search__controls">
                <button
                  @click="setBrick('prev')"
                  class="search__button search__button--left"
                  :disabled="!bricks || bricks.length <= 1"
                ></button>
                <div class="search__label" v-if="submitting">
                  Searching
                  <!-- <span class="search__count">Enter your name on the lfet to find your brick</span>   -->
                </div>
                <div class="search__label" v-else-if="bricks && bricks.length > 0">
                  Brick{{(bricks.length > 1) ? 's' : ''}} found
                  <span class="search__count" v-if="bricks.length > 1">{{brick+1}} of {{bricks.length}}</span>  
                </div>
                <div class="search__label" v-else-if="bricks">
                  No bricks found
                  <span class="search__count">Try again</span>  
                </div>
                <div class="search__label" v-else>
                  Find your brick
                  <span class="search__count">Search by name</span>  
                </div>
                <button
                  @click="setBrick('next')"
                  class="search__button search__button--right"
                  :disabled="!bricks || bricks.length <= 1"
                ></button>
              </div>
              <div class="search__options" >
                <div class="search__option" >
                  <div class="search__brick-bg" v-if="bricks && bricks.length > 0">
                    <transition mode="in-out" name="fade-brick">
                      <img v-show="bricks && bricks[brick] && bricks[brick].brickType == 1" src="../assets/1024/texture-brick-1-top.jpg" alt="">
                    </transition>
                    <transition mode="in-out" name="fade-brick">
                      <img v-show="bricks && bricks[brick] && bricks[brick].brickType == 2" src="../assets/1024/texture-brick-2-top.jpg" alt="">
                    </transition>
                    <transition mode="in-out" name="fade-brick">
                      <img v-show="bricks && bricks[brick] && bricks[brick].brickType == 3" src="../assets/1024/texture-brick-3-top.jpg" alt="">
                    </transition>
                  </div>
                  <div class="search__brick-bg" v-else>
                    <transition mode="in-out" name="fade-brick">
                      <img src="../assets/1024/texture-brick-1-top-blank.jpg" alt="">
                    </transition>
                  </div>
                  <div class="search__brick-name" v-if="bricks && bricks.length > 0">
                    {{bricks && bricks[brick] && bricks[brick].firstName}}
                    <br/>
                    {{bricks && bricks[brick] && bricks[brick].lastName}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button 
            class="button button--primary search__cta search__cta"
            type="submit"
            v-if="bricks && bricks.length > 0"
            @click="viewBrick"
          >
            View Brick
          </button>
          
        </div>

        
      </div>
    </transition>

  </div>
</template>

<script>

import axios from 'axios';
import * as Yup from 'yup'

export default {
  name: 'Search',

  components: {

  },

  data() {
    return {
      search: '',
      showForm: true,
      success: false,
      error: false,
      submitting: false,
      errors: {},
      brick: 0,
      // bricks: [{"id":1,"uid":"a0ub6lfqgb","firstName":"Linnie","lastName":"Wolff","brickType":2},{"id":2,"uid":"bvu0ww0utp","firstName":"Tom","lastName":"Schulte","brickType":3},{"id":3,"uid":"z5yc4b79s1","firstName":"Lora","lastName":"Terzani","brickType":1},{"id":4,"uid":"xnepoq63e8","firstName":"Bryan","lastName":"Marchand","brickType":3},{"id":5,"uid":"g5751w1gl9","firstName":"Paul","lastName":"Potts","brickType":3}],
      bricks: null,
    }
  },

  watch: {
    
  },

  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL
    },
  },

  mounted() {
    
  },

  methods: {

    goBack(){
      this.$emit('goBack', 'stage');
    },

    viewBrick(){
      window.location.href = this.baseUrl + '#' + this.bricks[this.brick].uid + '&searched';
      window.location.reload();
    },

    setBrick(type) {
      if(type == 'prev'){
        this.brick = this.brick == 0 ? this.bricks.length-1 : this.brick - 1;
      } else {
        this.brick = this.brick == this.bricks.length-1 ? 0 : this.brick + 1;
      }
    },

    async onSubmit(event) {

      event.preventDefault()

      await this.$recaptchaLoaded();
      const token = await this.$recaptcha();

      const values = {
        search: this.search,
      }

      const validationSchema = Yup.object({
        search: Yup.string().required('Search term is required.').test('len', 'Must be over 3 characters', val => val.length > 3),
      });

      // reset errors
      this.errors = {}

      try {
        await validationSchema.validate(values, { abortEarly: false })
      } catch (errors) {
        console.log(errors);
        this.errors = errors.inner.reduce((errors, error) => {
          errors[error.path] = error.message
          this.submitting = false;
          return errors
        }, {})
        return
      }

      this.submitting = true;
      this.bricks = []; 

      let response

      try {

        response = await axios.post(`${process.env.VUE_APP_API_URL}/search`, {
          token,
          search: this.search.toLowerCase(),
        });

        this.success = true;
        // this.brickId = response.data.uid;
        this.submitting = false;
        console.log(response);
        this.bricks = response.data;
      } catch (error) {
        
        if( !window.location.host.includes('eltonjohn.com') ){ // USE FALLBACK DATA LOCALLY SO WE DON'T NEED TO RUN API!!

          response = await fetch('/MOCK_DATA.json');
          response = await response.json();
          response = response.filter( brick => (brick.firstName + ' ' + brick.lastName).toLowerCase().includes( this.search.toLowerCase() ) );
          console.log( 'MOCK BRICKS FOUND', response.length );
          if( response.length > 0 ){
            this.success = true;
            this.submitting = false;
            this.bricks = response;
          }else{
            this.error = true;
            setTimeout(() => {
              this.submitting = false;
              this.error = false;
            }, 2500)
          }
        }else{
          this.error = true;
          setTimeout(() => {
            this.submitting = false;
            this.error = false;
          }, 2500)
          console.log(error)
        }
        
      }
    },
  },
}
</script>
